import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { ConfigFacadeService } from '@core/services/config/config-facade.service';
import { PartnerAliasEnum } from '@partners/partner-alias.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
	private readonly _authHeaderName = 'Authorization';

	constructor(private appConfig: ConfigFacadeService) {}

	public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (request.headers.has(this._authHeaderName)) {
			const requestWithAuthReviewed = this.reviewAuth(request);
			this.updateHostToken(requestWithAuthReviewed.headers.get(this._authHeaderName));
			return next.handle(requestWithAuthReviewed);
		}

		return next.handle(request);
	}

	private reviewAuth<T>(request: HttpRequest<T>): HttpRequest<T> {
		const partnerAlias = this.appConfig.config.partner?.prefix || '';
		if (partnerAlias === PartnerAliasEnum.Zesty) return request;

		return request.clone({
			setHeaders: {
				[this._authHeaderName]: `${request.headers.get(this._authHeaderName)}|${partnerAlias}`,
			},
		});
	}

	private updateHostToken<T>(authHeaderValue: string): void {
		const [, token] = authHeaderValue.split(' ');
		const isHostOutdated = window.zestyHost?.authToken !== token.trim();

		if (isHostOutdated) {
			window.zestyHost.authToken = token.trim();
		}
	}
}
